import React from "react";
import { BaseIconProps } from "../../types/styles";

const ClockIcon = ({
    id,
    className,
    size = 24,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--neutral-400)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-clock"}
            className={className}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12 6V12L16 14"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ClockIcon;
